import styled from '@emotion/styled';
import { Box, Grid, Paper } from '@material-ui/core';

export const ArrowSvgIconContainer = styled(Box)`
  color: #dce5ed;
  top: 38px;
  position: relative;
  width: 5%;
  display: flex;
  justify-content: center;
`;

export const AddContenRowContainer = styled(Box)`
  display: flex;

  .MuiFormControl-marginDense {
    margin: 0;
  }

  &:not(:nth-of-type(3)) {
    width: 50%;
  }

  &:nth-of-type(3) {
    > *:first-of-type {
      width: 50%;
    }

    > *:last-child {
      width: 45%;
    }
  }

  &:nth-of-type(4) {
    width: 60%;
  }

  &:nth-of-type(5) {
    width: 60%;
  }

  &:nth-of-type(7) {
    width: 35%;
  }
`;

export const AddContentFormDiv = styled.div`
  position: relative;
  flex-grow: 1;
  height: calc(100% - 122px);
`;

export const AddContentFormMainContainer = styled.form`
  height: calc(100% - 73px);
  overflow-y: auto;
  padding: 0 15px;
`;

export const AddContentFormContainer = styled(Paper)`
  width: 85%;
  max-width: 860px;
  margin: 15px auto;
`;

export const AddContentFormHeader = styled.div`
  padding: 8px 16px;
  background-color: #dce5ed;
  font-size: 13px;
  font-weight: 500;
  color: #6f8294;
`;

export const AddContentFormBox = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
`;

export const GridRow = styled(Grid)`
  margin: -24px 0 !important;
`;

export const AddContentFormButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 6px 12px;
  display: flex;
  flex-direction: row;
  border-top: solid rgba(100, 100, 100, 0.2) 1px;
  justify-content: center;
  height: 60px;
  align-items: center;
  z-index: 2;
  background-color: #fff;

  > button {
    margin: 0 8px;
  }
`;
